<script setup lang="ts">
import SidebarItem from "@/components/MyStudents/Navigation/SidebarItem.vue";
import type { NavigationSectionProps } from "@/components/OperationsApp/components/Navigation/types.ts";

defineOptions({ name: "CommunityBasedLearningSection" });

const props = withDefaults(defineProps<NavigationSectionProps>(), {
  showHiddenNav: false,
  showHeader: false,
});

const emit = defineEmits(["menu-item-clicked"]);

const handleMenuItemClick = () => {
  emit("menu-item-clicked");
};
</script>

<template>
  <div data-testid="community-based-learning-section">
    <div v-if="showHeader" class="mt-4" data-testid="community-based-learning-title">
      <h2
          class="font-montserrat font-bold text-university-primary mb-2"
      >
        Community Based Learning
      </h2>
      <hr class="border-t border-gray-475 mb-2" />
    </div>
    <ul class="space-y-2" data-testid="community-based-learning-list">
      <SidebarItem
        v-if="showHiddenNav"
        text="Collections"
        :router-link="{ name: 'operations-dashboard' }"
        data-test-id="community-based-learning-item-collections"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="collections_bookmark"
      />
      <SidebarItem
        v-if="showHiddenNav"
        text="Instances"
        :router-link="{ name: 'operations-dashboard' }"
        data-test-id="community-based-learning-item-instances"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="labs"
      />
      <SidebarItem
        v-if="showHiddenNav"
        text="Internships"
        :router-link="{ name: 'operations-dashboard' }"
        data-test-id="community-based-learning-item-internships"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="business_center"
      />
    </ul>
  </div>
</template>

<style scoped>

</style>
